import * as Yup from 'yup';

// Russell Logistics ("Russ") invoice number for an LTL load (Invoice # = Load #).
// Stored on StockOrders.ltlInvoiceNumber / StockTransfers.ltlInvoiceNumber
// (VARCHAR 120) so the QuickBooks worker can match Russ's ACH payments.
export const LTL_INVOICE_NUMBER_MAX_LENGTH = 120;

export const ltlInvoiceNumberSchema = Yup.string()
  .nullable()
  .trim()
  .max(
    LTL_INVOICE_NUMBER_MAX_LENGTH,
    `LTL Invoice # must be at most ${LTL_INVOICE_NUMBER_MAX_LENGTH} characters`
  );

/**
 * Prepares `ltlInvoiceNumber` for the create/edit request body.
 *
 * - A non-empty value is sent trimmed.
 * - An empty / whitespace-only value is not sent at all (the key is removed),
 *   so the body is exactly what it was before this field existed.
 * - Edit only: when the stored value (`storedValue`) was non-empty and the
 *   user cleared the field, `null` is sent so the stored number is removed.
 */
export const withLtlInvoiceNumber = <
  T extends { ltlInvoiceNumber?: string | null },
>(
  values: T,
  storedValue?: string | null
): T => {
  const { ltlInvoiceNumber, ...rest } = values;
  const trimmed =
    typeof ltlInvoiceNumber === 'string' ? ltlInvoiceNumber.trim() : '';

  if (trimmed) {
    return { ...rest, ltlInvoiceNumber: trimmed } as T;
  }

  if (typeof storedValue === 'string' && storedValue.trim()) {
    return { ...rest, ltlInvoiceNumber: null } as T;
  }

  return rest as T;
};
